module.exports = __webpack_public_path__ + "static/fonts/luengo-extrabold-webfont.82bdad4f.woff2";